import config from "./../config";
import ReloadOnBreakpoint from "reload-on-breakpoint";

const ReloadOnResize = () => {
  const bp = new ReloadOnBreakpoint([config.breakpointSM, config.breakpointMD]);
  bp.mount();
}

export default ReloadOnResize;